/*
 * Doto BNPL highlighted modal
 * Always opens the internal scroll area at the top.
 */

if (!window.__dotoBnplHighlightScrollTopInit) {
  window.__dotoBnplHighlightScrollTopInit = true;

  const resetScroll = (root) => {
    const content = root?.querySelector?.('.doto-bnpl-highlight__modal-content');
    if (!content) return;

    content.scrollTop = 0;
    content.scrollLeft = 0;

    if (typeof content.scrollTo === 'function') {
      content.scrollTo(0, 0);
    }
  };

  /*
   * Reset before opening so a previously opened modal does not preserve
   * its last scroll position.
   */
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('.doto-bnpl-highlight__link');
    if (!opener) return;

    const modalId = opener.getAttribute('target');
    if (!modalId) return;

    const modal = document.getElementById(modalId);
    resetScroll(modal);
  }, true);

  /*
   * Multi dispatches this event after the dialog has opened and its
   * opening animation is complete. Reset again here in case native focus
   * management moved the scroll position during opening.
   */
  document.addEventListener('modal-open', (event) => {
    const dialog = event.target;
    const modal = dialog?.closest?.('.doto-bnpl-highlight__modal') || dialog?.parentElement;

    if (!modal?.querySelector?.('.doto-bnpl-highlight__modal-content')) return;

    resetScroll(modal);

    requestAnimationFrame(() => {
      resetScroll(modal);
      requestAnimationFrame(() => resetScroll(modal));
    });
  });
}
